import React from 'react';
import { Slider, SliderThumb, Stack, Typography } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';

const StarThumb: React.FC<React.HTMLAttributes<HTMLSpanElement>> = ({
  children,
  ...props
}) => (
  <SliderThumb {...props}>
    {children}
    <StarIcon fontSize="small" />
  </SliderThumb>
);

const sliderSx = {
  color: 'text.link',
  py: 1.25,
  '& .MuiSlider-track': { border: 'none' },
  '& .MuiSlider-thumb': {
    width: '1.25rem',
    height: '1.25rem',
    backgroundColor: 'transparent',
    '&::before': { boxShadow: 'none' },
  },
};

interface ISeniorityRangeFieldProps {
  scale: string[];
  value: number[];
  onChange: (value: number[]) => void;
}

export const SeniorityRangeField: React.FC<ISeniorityRangeFieldProps> = ({
  scale,
  value,
  onChange,
}) => (
  <Stack>
    <Typography variant="caption" color="text.secondary">
      Seniority
    </Typography>

    <Slider
      size="small"
      value={value}
      min={0}
      max={scale.length - 1}
      marks
      disableSwap
      getAriaLabel={(index) =>
        index ? 'Highest seniority' : 'Lowest seniority'
      }
      getAriaValueText={(index) => scale[index]}
      onChange={(_, next) => onChange(next as number[])}
      slots={{ thumb: StarThumb }}
      sx={sliderSx}
    />

    <Stack direction="row" justifyContent="space-between">
      <Typography variant="body2" color="text.secondary">
        {scale[0]}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {scale[scale.length - 1]}
      </Typography>
    </Stack>
  </Stack>
);
